.avt-react-components--button {
  display: flex;
  align-items: center;
  font-weight: 500;
  box-sizing: border-box;
  border: 1px solid transparent;
  white-space: nowrap;
  cursor: pointer;
  line-height: 1;
  border-radius: 0.25rem;
  height: 2.2rem;
  padding: 0 0.6rem;
  font-size: 1rem;
}

.avt-react-components--button.variation-with-icon-left .avt-react-components--icon, .avt-react-components--button.variation-with-icon-right .avt-react-components--icon {
  width: 1.4rem;
  height: 1.4rem;
}

.avt-react-components--button.variation-with-icon-left {
  padding-left: 0.4rem;
}

.avt-react-components--button.variation-with-icon-left .avt-react-components--icon {
  margin-right: 0.4rem;
}

.avt-react-components--button.variation-with-icon-left.variation-slim {
  padding-left: 0.3rem;
}

.avt-react-components--button.variation-with-icon-right {
  padding-right: 0.4rem;
}

.avt-react-components--button.variation-with-icon-right .avt-react-components--icon {
  margin-left: 0.4rem;
}

.avt-react-components--button.variation-with-icon-right.variation-slim {
  padding-right: 0.3rem;
}

.avt-react-components--button.variation-slim {
  height: 1.6rem;
  padding: 0 0.4rem;
  font-size: 0.8rem;
}

.avt-react-components--button.variation-slim .avt-react-components--icon {
  width: 1rem;
  height: 1rem;
}

.avt-react-components--button.variation-childless {
  padding: 0 0.4rem;
}

.avt-react-components--button.variation-childless .avt-react-components--icon {
  margin-right: 0;
}

.avt-react-components--button.variation-childless.variation-slim {
  padding: 0 0.25rem;
}

.avt-react-components--button.design-outlined {
  border-width: 1px;
}

.avt-react-components--button.design-regular.activity-primary {
  background: #3366ff;
  color: #ffffff;
}

.avt-react-components--button.design-regular.activity-info {
  background: #3366ff;
  color: #ffffff;
}

.avt-react-components--button.design-regular.activity-success {
  background: #0ca919;
  color: #ffffff;
}

.avt-react-components--button.design-regular.activity-warning {
  background: #ffd800;
  color: #ffffff;
}

.avt-react-components--button.design-regular.activity-danger {
  background: #f03040;
  color: #ffffff;
}

.avt-react-components--button.design-outlined {
  background: transparent;
}

.avt-react-components--button.design-outlined.activity-primary {
  border-color: #3366ff;
  color: #3366ff;
}

.avt-react-components--button.design-outlined.activity-info {
  border-color: #3366ff;
  color: #3366ff;
}

.avt-react-components--button.design-outlined.activity-success {
  border-color: #0ca919;
  color: #0ca919;
}

.avt-react-components--button.design-outlined.activity-warning {
  border-color: #ffd800;
  color: #ffd800;
}

.avt-react-components--button.design-outlined.activity-danger {
  border-color: #f03040;
  color: #f03040;
}

.avt-react-components--button.design-text {
  height: auto;
  background: transparent;
  padding: 0;
}

.avt-react-components--button.design-text.activity-primary {
  color: #3366ff;
}

.avt-react-components--button.design-text.activity-info {
  color: #3366ff;
}

.avt-react-components--button.design-text.activity-success {
  color: #0ca919;
}

.avt-react-components--button.design-text.activity-warning {
  color: #ffd800;
}

.avt-react-components--button.design-text.activity-danger {
  color: #f03040;
}

.avt-react-components--button.theme-dark.design-regular.activity-secondary {
  background: #333333;
  color: #ffffff;
}

.avt-react-components--button.theme-dark.design-regular.activity-tertiary {
  background: rgb(76.5, 76.5, 76.5);
  color: #ffffff;
}

.avt-react-components--button.theme-dark.design-outlined.activity-secondary {
  border-color: #333333;
  color: #cccccc;
}

.avt-react-components--button.theme-dark.design-outlined.activity-tertiary {
  border-color: rgb(76.5, 76.5, 76.5);
  color: rgb(127.5, 127.5, 127.5);
  font-weight: 400;
}

.avt-react-components--button.theme-dark.design-text.activity-primary {
  color: rgb(229.5, 229.5, 229.5);
}

.avt-react-components--button.theme-dark.design-text.activity-secondary {
  color: rgb(127.5, 127.5, 127.5);
}

.avt-react-components--button.theme-dark.design-text.activity-tertiary {
  color: rgb(127.5, 127.5, 127.5);
  font-weight: 400;
}

.avt-react-components--button.theme-light.design-regular.activity-secondary {
  background: rgb(216.75, 216.75, 216.75);
  color: #666666;
}

.avt-react-components--button.theme-light.design-regular.activity-tertiary {
  background: #cccccc;
  color: rgb(76.5, 76.5, 76.5);
}

.avt-react-components--button.theme-light.design-outlined.activity-secondary {
  border-color: rgb(178.5, 178.5, 178.5);
  color: rgb(76.5, 76.5, 76.5);
}

.avt-react-components--button.theme-light.design-outlined.activity-tertiary {
  border-color: #cccccc;
  color: #666666;
  font-weight: 400;
}

.avt-react-components--button.theme-light.design-text.activity-primary {
  color: rgb(25.5, 25.5, 25.5);
}

.avt-react-components--button.theme-light.design-text.activity-secondary {
  color: #666666;
}

.avt-react-components--button.theme-light.design-text.activity-tertiary {
  color: #666666;
  font-weight: 400;
}

.avt-react-components--button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.avt-react-components--button[class*=-slim] {
  text-transform: uppercase;
}

.tooltip-box {
  border-radius: 0.25rem;
  font-size: 0.86rem;
  padding: 0.35rem 0.5rem 0.4rem 0.5rem;
  word-break: keep-all;
  white-space: normal;
  text-align: center;
  max-width: none;
}

.tooltip-box.theme-light {
  background-color: #333333;
  color: #ffffff;
}

.tooltip-box.theme-dark {
  background-color: rgb(242.25, 242.25, 242.25);
  color: black;
}

body.select-none {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.avt-react-components--button-group {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 0.25rem;
  max-height: 2.2rem !important;
}

.avt-react-components--button-group > :not(:last-child) {
  margin-right: 0.3rem;
}

.avt-react-components--button-group button {
  border: 1px solid transparent !important;
  outline: none !important;
  border-radius: 0.2rem;
  height: 1.7rem;
  width: 2rem;
}

.avt-react-components--button-group button.disabled {
  opacity: 0.4;
}

.avt-react-components--button-group.theme-light {
  background: rgb(216.75, 216.75, 216.75);
}

.avt-react-components--button-group.theme-light button {
  background: #ffffff !important;
}

.avt-react-components--button-group.theme-light button.disabled {
  background: none !important;
}

.avt-react-components--button-group.theme-dark {
  background: #333333;
}

.avt-react-components--button-group.theme-dark button {
  background: rgb(25.5, 25.5, 25.5) !important;
}

.avt-react-components--button-group.theme-dark button.disabled {
  background: none !important;
}

.avt-react-components--checkbox-container {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  position: relative;
}

.avt-react-components--checkbox-container > .avt-react-components--icon {
  position: absolute;
  top: -1px;
  bottom: 0;
  right: 0;
  left: 0;
  pointer-events: none;
}

.avt-react-components--checkbox-container > .avt-react-components--icon > svg {
  vertical-align: top;
}

.avt-react-components--checkbox-container .avt-react-components--checkbox-native {
  opacity: 0;
  cursor: pointer;
  margin: 0;
  width: 16px;
  height: 16px;
}

.avt-react-components--checkbox-container.checkbox-size-s .avt-react-components--checkbox-native {
  width: 16px;
  height: 16px;
}

.avt-react-components--checkbox-container.checkbox-size-m .avt-react-components--checkbox-native {
  width: 24px;
  height: 24px;
}

.avt-react-components--checkbox-container.checkbox-size-l .avt-react-components--checkbox-native {
  width: 32px;
  height: 32px;
}

.avt-react-components--checkbox-container .avt-react-components--checkbox-native:focus ~ .avt-react-components--icon {
  color: #3366ff !important;
}

.avt-react-components--checkbox-container .avt-react-components--checkbox-native + .avt-react-components--icon {
  display: none;
}

.avt-react-components--checkbox-container .avt-react-components--checkbox-native:checked + .avt-react-components--icon {
  display: inherit;
}

.avt-react-components--checkbox-container .avt-react-components--checkbox-native:disabled ~ .avt-react-components--icon {
  color: inherit !important;
  opacity: 0.5;
}

.avt-react-components--checkbox-container .avt-react-components--checkbox-native:disabled {
  cursor: not-allowed;
}

.avt-react-components--error {
  font-size: 0.75rem;
  line-height: 1rem;
  color: #e12e2e;
  padding: 0.2rem 0.4rem;
}

.avt-react-components--error.theme-dark {
  color: #ff99a0;
}

.avt-react-components--icon.xs {
  width: 12px;
  height: 12px;
}

.avt-react-components--icon.s {
  width: 16px;
  height: 16px;
}

.avt-react-components--icon.m {
  width: 24px;
  height: 24px;
}

.avt-react-components--icon.l {
  width: 32px;
  height: 32px;
}

.avt-react-components--icon svg {
  width: 100%;
  height: 100%;
}

.avt-react-components--input {
  padding: 0.466rem 0.5rem;
  font-size: 1rem;
  border: 1px solid #cccccc;
  border-radius: 0.3rem;
  width: 100%;
  box-sizing: border-box;
  transition: all 100ms;
}

.avt-react-components--input::placeholder {
  color: #666666;
}

.avt-react-components--input:hover:not(:focus) {
  border-color: rgb(178.5, 178.5, 178.5);
}

.avt-react-components--input.theme-dark {
  background-color: rgb(25.5, 25.5, 25.5);
  color: rgb(229.5, 229.5, 229.5);
  border-color: rgb(76.5, 76.5, 76.5);
}

.avt-react-components--input.theme-dark::placeholder {
  color: rgb(127.5, 127.5, 127.5);
}

.avt-react-components--input.theme-dark:hover:not(:focus) {
  border-color: #666666;
}

.avt-react-components--input:focus {
  outline: none;
  box-shadow: 0 0 0 1px #3366ff;
  border-color: #3366ff;
}

.avt-react-components--input:disabled {
  cursor: not-allowed;
}

.avt-react-components--label {
  line-height: 2rem;
}

.avt-react-components--label.theme-dark {
  color: rgb(229.5, 229.5, 229.5);
}

.avt-react-components--panel {
  background-color: rgb(229.5, 229.5, 229.5);
}

.avt-react-components--panel .panel-rounded {
  border-radius: 0.25rem;
}

.avt-react-components--panel .avt-react-components--panel {
  background-color: rgb(216.75, 216.75, 216.75);
}

.avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(242.25, 242.25, 242.25);
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: #cccccc;
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(229.5, 229.5, 229.5);
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: rgb(191.25, 191.25, 191.25);
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(216.75, 216.75, 216.75);
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: rgb(178.5, 178.5, 178.5);
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: #cccccc;
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: rgb(165.75, 165.75, 165.75);
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(191.25, 191.25, 191.25);
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: #999999;
}

.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(178.5, 178.5, 178.5);
}

.theme-dark.avt-react-components--panel {
  background-color: rgb(25.5, 25.5, 25.5);
}

.theme-dark.avt-react-components--panel.panel-descend {
  background-color: black;
}

.theme-dark.avt-react-components--panel .avt-react-components--panel {
  background-color: rgb(38.25, 38.25, 38.25);
}

.theme-dark.avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(12.75, 12.75, 12.75);
}

.theme-dark.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: #333333;
}

.theme-dark.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(25.5, 25.5, 25.5);
}

.theme-dark.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: rgb(63.75, 63.75, 63.75);
}

.theme-dark.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(38.25, 38.25, 38.25);
}

.theme-dark.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: rgb(76.5, 76.5, 76.5);
}

.theme-dark.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: #333333;
}

.theme-dark.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel {
  background-color: rgb(89.25, 89.25, 89.25);
}

.theme-dark.avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel .avt-react-components--panel.panel-descend {
  background-color: rgb(63.75, 63.75, 63.75);
}

.avt-react-components--spinner {
  position: relative;
  display: inline-block;
}

.avt-react-components--spinner.size-s {
  width: 16px;
  height: 16px;
}

.avt-react-components--spinner.size-m {
  width: 24px;
  height: 24px;
}

.avt-react-components--spinner.size-l {
  width: 32px;
  height: 32px;
}

.avt-react-components--spinner .avt-react-components--spinner--wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.avt-react-components--spinner svg {
  width: 100%;
  height: 100%;
  animation: avt-react-components--spinner--spin 2000ms infinite linear;
}

.avt-react-components--spinner.theme-light {
  color: rgb(76.5, 76.5, 76.5);
}

.avt-react-components--spinner.theme-dark {
  color: rgb(229.5, 229.5, 229.5);
}

@keyframes avt-react-components--spinner--spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.avt-react-components--textarea {
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #cccccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  transition: all 100ms;
}

.avt-react-components--textarea::placeholder {
  color: rgb(127.5, 127.5, 127.5);
}

.avt-react-components--textarea:hover:not(:focus) {
  border-color: rgb(178.5, 178.5, 178.5);
}

.avt-react-components--textarea.theme-dark {
  background-color: rgb(25.5, 25.5, 25.5);
  color: rgb(229.5, 229.5, 229.5);
  border-color: rgb(76.5, 76.5, 76.5);
}

.avt-react-components--textarea.theme-dark::placeholder {
  color: #999999;
}

.avt-react-components--textarea.theme-dark:hover:not(:focus) {
  border-color: #666666;
}

.avt-react-components--textarea:focus {
  outline: none;
  box-shadow: 0 0 0 1px #3366ff;
  border-color: #3366ff;
}

.avt-react-components--textarea:disabled {
  cursor: not-allowed;
}


.site-detail-view-component {
  padding-left: 4rem;
}

.no-side-margin {
  padding-left: 0 !important;
}

.base-view {
  padding-left: 4rem;
  padding-top: 1px;
}
.base-view .panel {
  padding-top: 4.5rem;
  flex-direction: column;
  background-color: white;
  margin-right: 1rem;
  margin-left: 15rem;
}
.base-view .panel-header {
  display: flex;
  background-color: #f2f2f2;
  padding: 1.5rem;
  padding-right: 0;
  justify-content: space-between;
  flex-direction: row;
}
.base-view .panel-header-button {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  font-size: small;
}
.base-view .loading-container {
  width: 100%;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  display: none;
  padding: 1rem 1.5rem;
}

.content.active {
  display: block;
}

.preview-text {
  padding: 1.5rem;
}

.preview-text span {
  margin-top: 1rem;
}

.dark-theme .panel {
  background: rgb(38.25, 38.25, 38.25);
  color: rgb(229.5, 229.5, 229.5);
}
.dark-theme .panel .panel-header {
  background: rgb(38.25, 38.25, 38.25);
  color: rgb(229.5, 229.5, 229.5);
}
.dark-theme .panel .sidebar {
  background: rgb(38.25, 38.25, 38.25);
  color: rgb(229.5, 229.5, 229.5);
}
.dark-theme .panel .sidebar .site-list .site {
  color: rgb(127.5, 127.5, 127.5);
  border-color: #333333;
}
.dark-theme .panel .sidebar .site-list .site .thumbnail {
  border-color: #333333;
}
.dark-theme .panel .sidebar .site-list .site .name {
  color: rgb(229.5, 229.5, 229.5);
}
.dark-theme .panel .sidebar .site-list .site span {
  color: rgb(229.5, 229.5, 229.5);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvQXBwIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9ub2RlX21vZHVsZXMvQGlxL3JlYWN0LWNvbXBvbmVudHMvZGlzdC9pbmRleC5zY3NzIiwiQXBwLnNjc3MiLCIuLi8uLi8uLi8uLi9ub2RlX21vZHVsZXMvQGlxL3JlYWN0LWNvbXBvbmVudHMvZGlzdC9jb2xvcnMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7OztBQUVGO0VBQ0U7OztBQUVGO0VBQ0U7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7OztBQUVGO0VBQ0U7OztBQUVGO0VBQ0U7RUFDQTtFQUNBOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBRUY7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7OztBQUVGO0VBQ0U7RUFDQTs7O0FBRUY7RUFDRTtFQUNBOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7OztBQUVGO0VBQ0U7OztBQUdGO0VBQ0U7SUFDRTs7RUFFRjtJQUNFOzs7QUFHSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFOzs7QUFFRjtFQUNFO0VBQ0E7RUFDQTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7OztBQUVGO0VBQ0U7Ozs7QUMvZ0JGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUlKO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBSUE7RUFDRSxZQzFCSztFRDJCTCxPQzFDSzs7QUQ0Q0w7RUFDRSxZQzlCRztFRCtCSCxPQzlDRzs7QURpREw7RUFDRSxZQ25DRztFRG9DSCxPQ25ERzs7QURzREQ7RUFDRSxPQy9DRDtFRGdEQyxjQzFDRDs7QUQ0Q0M7RUFDRSxjQzdDSDs7QURnREM7RUFDRSxPQy9ESDs7QURrRUM7RUFDRSxPQ25FSCIsInNvdXJjZXNDb250ZW50IjpbIi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgYm9yZGVyOiAxcHggc29saWQgdHJhbnNwYXJlbnQ7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgbGluZS1oZWlnaHQ6IDE7XG4gIGJvcmRlci1yYWRpdXM6IDAuMjVyZW07XG4gIGhlaWdodDogMi4ycmVtO1xuICBwYWRkaW5nOiAwIDAuNnJlbTtcbiAgZm9udC1zaXplOiAxcmVtO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udmFyaWF0aW9uLXdpdGgtaWNvbi1sZWZ0IC5hdnQtcmVhY3QtY29tcG9uZW50cy0taWNvbiwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udmFyaWF0aW9uLXdpdGgtaWNvbi1yaWdodCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24ge1xuICB3aWR0aDogMS40cmVtO1xuICBoZWlnaHQ6IDEuNHJlbTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLnZhcmlhdGlvbi13aXRoLWljb24tbGVmdCB7XG4gIHBhZGRpbmctbGVmdDogMC40cmVtO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udmFyaWF0aW9uLXdpdGgtaWNvbi1sZWZ0IC5hdnQtcmVhY3QtY29tcG9uZW50cy0taWNvbiB7XG4gIG1hcmdpbi1yaWdodDogMC40cmVtO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udmFyaWF0aW9uLXdpdGgtaWNvbi1sZWZ0LnZhcmlhdGlvbi1zbGltIHtcbiAgcGFkZGluZy1sZWZ0OiAwLjNyZW07XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi52YXJpYXRpb24td2l0aC1pY29uLXJpZ2h0IHtcbiAgcGFkZGluZy1yaWdodDogMC40cmVtO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udmFyaWF0aW9uLXdpdGgtaWNvbi1yaWdodCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24ge1xuICBtYXJnaW4tbGVmdDogMC40cmVtO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udmFyaWF0aW9uLXdpdGgtaWNvbi1yaWdodC52YXJpYXRpb24tc2xpbSB7XG4gIHBhZGRpbmctcmlnaHQ6IDAuM3JlbTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLnZhcmlhdGlvbi1zbGltIHtcbiAgaGVpZ2h0OiAxLjZyZW07XG4gIHBhZGRpbmc6IDAgMC40cmVtO1xuICBmb250LXNpemU6IDAuOHJlbTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLnZhcmlhdGlvbi1zbGltIC5hdnQtcmVhY3QtY29tcG9uZW50cy0taWNvbiB7XG4gIHdpZHRoOiAxcmVtO1xuICBoZWlnaHQ6IDFyZW07XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi52YXJpYXRpb24tY2hpbGRsZXNzIHtcbiAgcGFkZGluZzogMCAwLjRyZW07XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi52YXJpYXRpb24tY2hpbGRsZXNzIC5hdnQtcmVhY3QtY29tcG9uZW50cy0taWNvbiB7XG4gIG1hcmdpbi1yaWdodDogMDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLnZhcmlhdGlvbi1jaGlsZGxlc3MudmFyaWF0aW9uLXNsaW0ge1xuICBwYWRkaW5nOiAwIDAuMjVyZW07XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi5kZXNpZ24tb3V0bGluZWQge1xuICBib3JkZXItd2lkdGg6IDFweDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi1yZWd1bGFyLmFjdGl2aXR5LXByaW1hcnkge1xuICBiYWNrZ3JvdW5kOiAjMzM2NmZmO1xuICBjb2xvcjogI2ZmZmZmZjtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi1yZWd1bGFyLmFjdGl2aXR5LWluZm8ge1xuICBiYWNrZ3JvdW5kOiAjMzM2NmZmO1xuICBjb2xvcjogI2ZmZmZmZjtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi1yZWd1bGFyLmFjdGl2aXR5LXN1Y2Nlc3Mge1xuICBiYWNrZ3JvdW5kOiAjMGNhOTE5O1xuICBjb2xvcjogI2ZmZmZmZjtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi1yZWd1bGFyLmFjdGl2aXR5LXdhcm5pbmcge1xuICBiYWNrZ3JvdW5kOiAjZmZkODAwO1xuICBjb2xvcjogI2ZmZmZmZjtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi1yZWd1bGFyLmFjdGl2aXR5LWRhbmdlciB7XG4gIGJhY2tncm91bmQ6ICNmMDMwNDA7XG4gIGNvbG9yOiAjZmZmZmZmO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24uZGVzaWduLW91dGxpbmVkIHtcbiAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi5kZXNpZ24tb3V0bGluZWQuYWN0aXZpdHktcHJpbWFyeSB7XG4gIGJvcmRlci1jb2xvcjogIzMzNjZmZjtcbiAgY29sb3I6ICMzMzY2ZmY7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi5kZXNpZ24tb3V0bGluZWQuYWN0aXZpdHktaW5mbyB7XG4gIGJvcmRlci1jb2xvcjogIzMzNjZmZjtcbiAgY29sb3I6ICMzMzY2ZmY7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi5kZXNpZ24tb3V0bGluZWQuYWN0aXZpdHktc3VjY2VzcyB7XG4gIGJvcmRlci1jb2xvcjogIzBjYTkxOTtcbiAgY29sb3I6ICMwY2E5MTk7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi5kZXNpZ24tb3V0bGluZWQuYWN0aXZpdHktd2FybmluZyB7XG4gIGJvcmRlci1jb2xvcjogI2ZmZDgwMDtcbiAgY29sb3I6ICNmZmQ4MDA7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi5kZXNpZ24tb3V0bGluZWQuYWN0aXZpdHktZGFuZ2VyIHtcbiAgYm9yZGVyLWNvbG9yOiAjZjAzMDQwO1xuICBjb2xvcjogI2YwMzA0MDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi10ZXh0IHtcbiAgaGVpZ2h0OiBhdXRvO1xuICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbiAgcGFkZGluZzogMDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi10ZXh0LmFjdGl2aXR5LXByaW1hcnkge1xuICBjb2xvcjogIzMzNjZmZjtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi10ZXh0LmFjdGl2aXR5LWluZm8ge1xuICBjb2xvcjogIzMzNjZmZjtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi10ZXh0LmFjdGl2aXR5LXN1Y2Nlc3Mge1xuICBjb2xvcjogIzBjYTkxOTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi10ZXh0LmFjdGl2aXR5LXdhcm5pbmcge1xuICBjb2xvcjogI2ZmZDgwMDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLmRlc2lnbi10ZXh0LmFjdGl2aXR5LWRhbmdlciB7XG4gIGNvbG9yOiAjZjAzMDQwO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udGhlbWUtZGFyay5kZXNpZ24tcmVndWxhci5hY3Rpdml0eS1zZWNvbmRhcnkge1xuICBiYWNrZ3JvdW5kOiAjMzMzMzMzO1xuICBjb2xvcjogI2ZmZmZmZjtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLnRoZW1lLWRhcmsuZGVzaWduLXJlZ3VsYXIuYWN0aXZpdHktdGVydGlhcnkge1xuICBiYWNrZ3JvdW5kOiByZ2IoNzYuNSwgNzYuNSwgNzYuNSk7XG4gIGNvbG9yOiAjZmZmZmZmO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udGhlbWUtZGFyay5kZXNpZ24tb3V0bGluZWQuYWN0aXZpdHktc2Vjb25kYXJ5IHtcbiAgYm9yZGVyLWNvbG9yOiAjMzMzMzMzO1xuICBjb2xvcjogI2NjY2NjYztcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLnRoZW1lLWRhcmsuZGVzaWduLW91dGxpbmVkLmFjdGl2aXR5LXRlcnRpYXJ5IHtcbiAgYm9yZGVyLWNvbG9yOiByZ2IoNzYuNSwgNzYuNSwgNzYuNSk7XG4gIGNvbG9yOiByZ2IoMTI3LjUsIDEyNy41LCAxMjcuNSk7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi50aGVtZS1kYXJrLmRlc2lnbi10ZXh0LmFjdGl2aXR5LXByaW1hcnkge1xuICBjb2xvcjogcmdiKDIyOS41LCAyMjkuNSwgMjI5LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udGhlbWUtZGFyay5kZXNpZ24tdGV4dC5hY3Rpdml0eS1zZWNvbmRhcnkge1xuICBjb2xvcjogcmdiKDEyNy41LCAxMjcuNSwgMTI3LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udGhlbWUtZGFyay5kZXNpZ24tdGV4dC5hY3Rpdml0eS10ZXJ0aWFyeSB7XG4gIGNvbG9yOiByZ2IoMTI3LjUsIDEyNy41LCAxMjcuNSk7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi50aGVtZS1saWdodC5kZXNpZ24tcmVndWxhci5hY3Rpdml0eS1zZWNvbmRhcnkge1xuICBiYWNrZ3JvdW5kOiByZ2IoMjE2Ljc1LCAyMTYuNzUsIDIxNi43NSk7XG4gIGNvbG9yOiAjNjY2NjY2O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udGhlbWUtbGlnaHQuZGVzaWduLXJlZ3VsYXIuYWN0aXZpdHktdGVydGlhcnkge1xuICBiYWNrZ3JvdW5kOiAjY2NjY2NjO1xuICBjb2xvcjogcmdiKDc2LjUsIDc2LjUsIDc2LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udGhlbWUtbGlnaHQuZGVzaWduLW91dGxpbmVkLmFjdGl2aXR5LXNlY29uZGFyeSB7XG4gIGJvcmRlci1jb2xvcjogcmdiKDE3OC41LCAxNzguNSwgMTc4LjUpO1xuICBjb2xvcjogcmdiKDc2LjUsIDc2LjUsIDc2LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udGhlbWUtbGlnaHQuZGVzaWduLW91dGxpbmVkLmFjdGl2aXR5LXRlcnRpYXJ5IHtcbiAgYm9yZGVyLWNvbG9yOiAjY2NjY2NjO1xuICBjb2xvcjogIzY2NjY2NjtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLnRoZW1lLWxpZ2h0LmRlc2lnbi10ZXh0LmFjdGl2aXR5LXByaW1hcnkge1xuICBjb2xvcjogcmdiKDI1LjUsIDI1LjUsIDI1LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24udGhlbWUtbGlnaHQuZGVzaWduLXRleHQuYWN0aXZpdHktc2Vjb25kYXJ5IHtcbiAgY29sb3I6ICM2NjY2NjY7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi50aGVtZS1saWdodC5kZXNpZ24tdGV4dC5hY3Rpdml0eS10ZXJ0aWFyeSB7XG4gIGNvbG9yOiAjNjY2NjY2O1xuICBmb250LXdlaWdodDogNDAwO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b246ZGlzYWJsZWQge1xuICBvcGFjaXR5OiAwLjQ7XG4gIGN1cnNvcjogbm90LWFsbG93ZWQ7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbltjbGFzcyo9LXNsaW1dIHtcbiAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbn1cblxuLnRvb2x0aXAtYm94IHtcbiAgYm9yZGVyLXJhZGl1czogMC4yNXJlbTtcbiAgZm9udC1zaXplOiAwLjg2cmVtO1xuICBwYWRkaW5nOiAwLjM1cmVtIDAuNXJlbSAwLjRyZW0gMC41cmVtO1xuICB3b3JkLWJyZWFrOiBrZWVwLWFsbDtcbiAgd2hpdGUtc3BhY2U6IG5vcm1hbDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBtYXgtd2lkdGg6IG5vbmU7XG59XG4udG9vbHRpcC1ib3gudGhlbWUtbGlnaHQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjMzMzMzMzO1xuICBjb2xvcjogI2ZmZmZmZjtcbn1cbi50b29sdGlwLWJveC50aGVtZS1kYXJrIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDI0Mi4yNSwgMjQyLjI1LCAyNDIuMjUpO1xuICBjb2xvcjogYmxhY2s7XG59XG5cbmJvZHkuc2VsZWN0LW5vbmUge1xuICAtd2Via2l0LXVzZXItc2VsZWN0OiBub25lO1xuICAtbW96LXVzZXItc2VsZWN0OiBub25lO1xuICAtbXMtdXNlci1zZWxlY3Q6IG5vbmU7XG4gIHVzZXItc2VsZWN0OiBub25lO1xufVxuXG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi1ncm91cCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBwYWRkaW5nOiAwLjI1cmVtO1xuICBib3JkZXItcmFkaXVzOiAwLjI1cmVtO1xuICBtYXgtaGVpZ2h0OiAyLjJyZW0gIWltcG9ydGFudDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLWdyb3VwID4gOm5vdCg6bGFzdC1jaGlsZCkge1xuICBtYXJnaW4tcmlnaHQ6IDAuM3JlbTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLWdyb3VwIGJ1dHRvbiB7XG4gIGJvcmRlcjogMXB4IHNvbGlkIHRyYW5zcGFyZW50ICFpbXBvcnRhbnQ7XG4gIG91dGxpbmU6IG5vbmUgIWltcG9ydGFudDtcbiAgYm9yZGVyLXJhZGl1czogMC4ycmVtO1xuICBoZWlnaHQ6IDEuN3JlbTtcbiAgd2lkdGg6IDJyZW07XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi1ncm91cCBidXR0b24uZGlzYWJsZWQge1xuICBvcGFjaXR5OiAwLjQ7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWJ1dHRvbi1ncm91cC50aGVtZS1saWdodCB7XG4gIGJhY2tncm91bmQ6IHJnYigyMTYuNzUsIDIxNi43NSwgMjE2Ljc1KTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLWdyb3VwLnRoZW1lLWxpZ2h0IGJ1dHRvbiB7XG4gIGJhY2tncm91bmQ6ICNmZmZmZmYgIWltcG9ydGFudDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLWdyb3VwLnRoZW1lLWxpZ2h0IGJ1dHRvbi5kaXNhYmxlZCB7XG4gIGJhY2tncm91bmQ6IG5vbmUgIWltcG9ydGFudDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLWdyb3VwLnRoZW1lLWRhcmsge1xuICBiYWNrZ3JvdW5kOiAjMzMzMzMzO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24tZ3JvdXAudGhlbWUtZGFyayBidXR0b24ge1xuICBiYWNrZ3JvdW5kOiByZ2IoMjUuNSwgMjUuNSwgMjUuNSkgIWltcG9ydGFudDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tYnV0dG9uLWdyb3VwLnRoZW1lLWRhcmsgYnV0dG9uLmRpc2FibGVkIHtcbiAgYmFja2dyb3VuZDogbm9uZSAhaW1wb3J0YW50O1xufVxuXG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWNoZWNrYm94LWNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1jb250YWluZXIgPiAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24ge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogLTFweDtcbiAgYm90dG9tOiAwO1xuICByaWdodDogMDtcbiAgbGVmdDogMDtcbiAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWNoZWNrYm94LWNvbnRhaW5lciA+IC5hdnQtcmVhY3QtY29tcG9uZW50cy0taWNvbiA+IHN2ZyB7XG4gIHZlcnRpY2FsLWFsaWduOiB0b3A7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWNoZWNrYm94LWNvbnRhaW5lciAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWNoZWNrYm94LW5hdGl2ZSB7XG4gIG9wYWNpdHk6IDA7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgbWFyZ2luOiAwO1xuICB3aWR0aDogMTZweDtcbiAgaGVpZ2h0OiAxNnB4O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1jb250YWluZXIuY2hlY2tib3gtc2l6ZS1zIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tY2hlY2tib3gtbmF0aXZlIHtcbiAgd2lkdGg6IDE2cHg7XG4gIGhlaWdodDogMTZweDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tY2hlY2tib3gtY29udGFpbmVyLmNoZWNrYm94LXNpemUtbSAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWNoZWNrYm94LW5hdGl2ZSB7XG4gIHdpZHRoOiAyNHB4O1xuICBoZWlnaHQ6IDI0cHg7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWNoZWNrYm94LWNvbnRhaW5lci5jaGVja2JveC1zaXplLWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1uYXRpdmUge1xuICB3aWR0aDogMzJweDtcbiAgaGVpZ2h0OiAzMnB4O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1jb250YWluZXIgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1uYXRpdmU6Zm9jdXMgfiAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24ge1xuICBjb2xvcjogIzMzNjZmZiAhaW1wb3J0YW50O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1jb250YWluZXIgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1uYXRpdmUgKyAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24ge1xuICBkaXNwbGF5OiBub25lO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1jb250YWluZXIgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1jaGVja2JveC1uYXRpdmU6Y2hlY2tlZCArIC5hdnQtcmVhY3QtY29tcG9uZW50cy0taWNvbiB7XG4gIGRpc3BsYXk6IGluaGVyaXQ7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWNoZWNrYm94LWNvbnRhaW5lciAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWNoZWNrYm94LW5hdGl2ZTpkaXNhYmxlZCB+IC5hdnQtcmVhY3QtY29tcG9uZW50cy0taWNvbiB7XG4gIGNvbG9yOiBpbmhlcml0ICFpbXBvcnRhbnQ7XG4gIG9wYWNpdHk6IDAuNTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tY2hlY2tib3gtY29udGFpbmVyIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tY2hlY2tib3gtbmF0aXZlOmRpc2FibGVkIHtcbiAgY3Vyc29yOiBub3QtYWxsb3dlZDtcbn1cblxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1lcnJvciB7XG4gIGZvbnQtc2l6ZTogMC43NXJlbTtcbiAgbGluZS1oZWlnaHQ6IDFyZW07XG4gIGNvbG9yOiAjZTEyZTJlO1xuICBwYWRkaW5nOiAwLjJyZW0gMC40cmVtO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1lcnJvci50aGVtZS1kYXJrIHtcbiAgY29sb3I6ICNmZjk5YTA7XG59XG5cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0taWNvbi54cyB7XG4gIHdpZHRoOiAxMnB4O1xuICBoZWlnaHQ6IDEycHg7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24ucyB7XG4gIHdpZHRoOiAxNnB4O1xuICBoZWlnaHQ6IDE2cHg7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24ubSB7XG4gIHdpZHRoOiAyNHB4O1xuICBoZWlnaHQ6IDI0cHg7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24ubCB7XG4gIHdpZHRoOiAzMnB4O1xuICBoZWlnaHQ6IDMycHg7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWljb24gc3ZnIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1pbnB1dCB7XG4gIHBhZGRpbmc6IDAuNDY2cmVtIDAuNXJlbTtcbiAgZm9udC1zaXplOiAxcmVtO1xuICBib3JkZXI6IDFweCBzb2xpZCAjY2NjY2NjO1xuICBib3JkZXItcmFkaXVzOiAwLjNyZW07XG4gIHdpZHRoOiAxMDAlO1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB0cmFuc2l0aW9uOiBhbGwgMTAwbXM7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWlucHV0OjpwbGFjZWhvbGRlciB7XG4gIGNvbG9yOiAjNjY2NjY2O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1pbnB1dDpob3Zlcjpub3QoOmZvY3VzKSB7XG4gIGJvcmRlci1jb2xvcjogcmdiKDE3OC41LCAxNzguNSwgMTc4LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1pbnB1dC50aGVtZS1kYXJrIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDI1LjUsIDI1LjUsIDI1LjUpO1xuICBjb2xvcjogcmdiKDIyOS41LCAyMjkuNSwgMjI5LjUpO1xuICBib3JkZXItY29sb3I6IHJnYig3Ni41LCA3Ni41LCA3Ni41KTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0taW5wdXQudGhlbWUtZGFyazo6cGxhY2Vob2xkZXIge1xuICBjb2xvcjogcmdiKDEyNy41LCAxMjcuNSwgMTI3LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1pbnB1dC50aGVtZS1kYXJrOmhvdmVyOm5vdCg6Zm9jdXMpIHtcbiAgYm9yZGVyLWNvbG9yOiAjNjY2NjY2O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1pbnB1dDpmb2N1cyB7XG4gIG91dGxpbmU6IG5vbmU7XG4gIGJveC1zaGFkb3c6IDAgMCAwIDFweCAjMzM2NmZmO1xuICBib3JkZXItY29sb3I6ICMzMzY2ZmY7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLWlucHV0OmRpc2FibGVkIHtcbiAgY3Vyc29yOiBub3QtYWxsb3dlZDtcbn1cblxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1sYWJlbCB7XG4gIGxpbmUtaGVpZ2h0OiAycmVtO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1sYWJlbC50aGVtZS1kYXJrIHtcbiAgY29sb3I6IHJnYigyMjkuNSwgMjI5LjUsIDIyOS41KTtcbn1cblxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYigyMjkuNSwgMjI5LjUsIDIyOS41KTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLnBhbmVsLXJvdW5kZWQge1xuICBib3JkZXItcmFkaXVzOiAwLjI1cmVtO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDIxNi43NSwgMjE2Ljc1LCAyMTYuNzUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsLnBhbmVsLWRlc2NlbmQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IoMjQyLjI1LCAyNDIuMjUsIDI0Mi4yNSk7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNjY2NjY2M7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbC5wYW5lbC1kZXNjZW5kIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDIyOS41LCAyMjkuNSwgMjI5LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYigxOTEuMjUsIDE5MS4yNSwgMTkxLjI1KTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwucGFuZWwtZGVzY2VuZCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYigyMTYuNzUsIDIxNi43NSwgMjE2Ljc1KTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYigxNzguNSwgMTc4LjUsIDE3OC41KTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbC5wYW5lbC1kZXNjZW5kIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2NjY2NjYztcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDE2NS43NSwgMTY1Ljc1LCAxNjUuNzUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwucGFuZWwtZGVzY2VuZCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYigxOTEuMjUsIDE5MS4yNSwgMTkxLjI1KTtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjOTk5OTk5O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbC5wYW5lbC1kZXNjZW5kIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDE3OC41LCAxNzguNSwgMTc4LjUpO1xufVxuXG4udGhlbWUtZGFyay5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IoMjUuNSwgMjUuNSwgMjUuNSk7XG59XG4udGhlbWUtZGFyay5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwucGFuZWwtZGVzY2VuZCB7XG4gIGJhY2tncm91bmQtY29sb3I6IGJsYWNrO1xufVxuLnRoZW1lLWRhcmsuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IoMzguMjUsIDM4LjI1LCAzOC4yNSk7XG59XG4udGhlbWUtZGFyay5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbC5wYW5lbC1kZXNjZW5kIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDEyLjc1LCAxMi43NSwgMTIuNzUpO1xufVxuLnRoZW1lLWRhcmsuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICMzMzMzMzM7XG59XG4udGhlbWUtZGFyay5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsLnBhbmVsLWRlc2NlbmQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IoMjUuNSwgMjUuNSwgMjUuNSk7XG59XG4udGhlbWUtZGFyay5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IoNjMuNzUsIDYzLjc1LCA2My43NSk7XG59XG4udGhlbWUtZGFyay5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwucGFuZWwtZGVzY2VuZCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYigzOC4yNSwgMzguMjUsIDM4LjI1KTtcbn1cbi50aGVtZS1kYXJrLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDc2LjUsIDc2LjUsIDc2LjUpO1xufVxuLnRoZW1lLWRhcmsuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwucGFuZWwtZGVzY2VuZCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICMzMzMzMzM7XG59XG4udGhlbWUtZGFyay5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDg5LjI1LCA4OS4yNSwgODkuMjUpO1xufVxuLnRoZW1lLWRhcmsuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbCAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXBhbmVsIC5hdnQtcmVhY3QtY29tcG9uZW50cy0tcGFuZWwgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1wYW5lbC5wYW5lbC1kZXNjZW5kIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiKDYzLjc1LCA2My43NSwgNjMuNzUpO1xufVxuXG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXNwaW5uZXIge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tc3Bpbm5lci5zaXplLXMge1xuICB3aWR0aDogMTZweDtcbiAgaGVpZ2h0OiAxNnB4O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1zcGlubmVyLnNpemUtbSB7XG4gIHdpZHRoOiAyNHB4O1xuICBoZWlnaHQ6IDI0cHg7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXNwaW5uZXIuc2l6ZS1sIHtcbiAgd2lkdGg6IDMycHg7XG4gIGhlaWdodDogMzJweDtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tc3Bpbm5lciAuYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXNwaW5uZXItLXdyYXBwZXIge1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGxlZnQ6IDUwJTtcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS1zcGlubmVyIHN2ZyB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGFuaW1hdGlvbjogYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXNwaW5uZXItLXNwaW4gMjAwMG1zIGluZmluaXRlIGxpbmVhcjtcbn1cbi5hdnQtcmVhY3QtY29tcG9uZW50cy0tc3Bpbm5lci50aGVtZS1saWdodCB7XG4gIGNvbG9yOiByZ2IoNzYuNSwgNzYuNSwgNzYuNSk7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXNwaW5uZXIudGhlbWUtZGFyayB7XG4gIGNvbG9yOiByZ2IoMjI5LjUsIDIyOS41LCAyMjkuNSk7XG59XG5cbkBrZXlmcmFtZXMgYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXNwaW5uZXItLXNwaW4ge1xuICAwJSB7XG4gICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7XG4gIH1cbiAgMTAwJSB7XG4gICAgdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTtcbiAgfVxufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS10ZXh0YXJlYSB7XG4gIHBhZGRpbmc6IDAuNXJlbTtcbiAgZm9udC1zaXplOiAxcmVtO1xuICBib3JkZXI6IDFweCBzb2xpZCAjY2NjY2NjO1xuICBib3JkZXItcmFkaXVzOiA0cHg7XG4gIHdpZHRoOiAxMDAlO1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB0cmFuc2l0aW9uOiBhbGwgMTAwbXM7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXRleHRhcmVhOjpwbGFjZWhvbGRlciB7XG4gIGNvbG9yOiByZ2IoMTI3LjUsIDEyNy41LCAxMjcuNSk7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXRleHRhcmVhOmhvdmVyOm5vdCg6Zm9jdXMpIHtcbiAgYm9yZGVyLWNvbG9yOiByZ2IoMTc4LjUsIDE3OC41LCAxNzguNSk7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXRleHRhcmVhLnRoZW1lLWRhcmsge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IoMjUuNSwgMjUuNSwgMjUuNSk7XG4gIGNvbG9yOiByZ2IoMjI5LjUsIDIyOS41LCAyMjkuNSk7XG4gIGJvcmRlci1jb2xvcjogcmdiKDc2LjUsIDc2LjUsIDc2LjUpO1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS10ZXh0YXJlYS50aGVtZS1kYXJrOjpwbGFjZWhvbGRlciB7XG4gIGNvbG9yOiAjOTk5OTk5O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS10ZXh0YXJlYS50aGVtZS1kYXJrOmhvdmVyOm5vdCg6Zm9jdXMpIHtcbiAgYm9yZGVyLWNvbG9yOiAjNjY2NjY2O1xufVxuLmF2dC1yZWFjdC1jb21wb25lbnRzLS10ZXh0YXJlYTpmb2N1cyB7XG4gIG91dGxpbmU6IG5vbmU7XG4gIGJveC1zaGFkb3c6IDAgMCAwIDFweCAjMzM2NmZmO1xuICBib3JkZXItY29sb3I6ICMzMzY2ZmY7XG59XG4uYXZ0LXJlYWN0LWNvbXBvbmVudHMtLXRleHRhcmVhOmRpc2FibGVkIHtcbiAgY3Vyc29yOiBub3QtYWxsb3dlZDtcbn1cblxuLyojIHNvdXJjZU1hcHBpbmdVUkw9aW5kZXguc2Nzcy5tYXAgKi9cbiIsIkB1c2UgJ0BpcS9yZWFjdC1jb21wb25lbnRzL2Rpc3QvY29sb3JzLnNjc3MnIGFzIGNvbG9ycztcbkB1c2UgJ0BpcS9yZWFjdC1jb21wb25lbnRzL2Rpc3QvaW5kZXguc2NzcycgYXMgaW5kZXg7XG5cbi5zaXRlLWRldGFpbC12aWV3LWNvbXBvbmVudCB7XG4gIHBhZGRpbmctbGVmdDogNHJlbTtcbn1cblxuLm5vLXNpZGUtbWFyZ2luIHtcbiAgcGFkZGluZy1sZWZ0OiAwICFpbXBvcnRhbnQ7XG59XG5cbi5iYXNlLXZpZXcge1xuICBwYWRkaW5nLWxlZnQ6IDRyZW07XG4gIHBhZGRpbmctdG9wOiAxcHg7XG5cbiAgLnBhbmVsIHtcbiAgICBwYWRkaW5nLXRvcDogNC41cmVtO1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7XG4gICAgbWFyZ2luLXJpZ2h0OiAxcmVtO1xuICAgIG1hcmdpbi1sZWZ0OiAxNXJlbTtcbiAgfVxuXG4gIC5wYW5lbC1oZWFkZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2YyZjJmMjtcbiAgICBwYWRkaW5nOiAxLjVyZW07XG4gICAgcGFkZGluZy1yaWdodDogMDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgfVxuXG4gIC5wYW5lbC1oZWFkZXItYnV0dG9uIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgZ2FwOiAxcmVtO1xuICAgIGZvbnQtc2l6ZTogc21hbGw7XG4gIH1cblxuICAubG9hZGluZy1jb250YWluZXIge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogOTB2aDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIH1cbn1cblxuLmNvbnRlbnQge1xuICBkaXNwbGF5OiBub25lO1xuICBwYWRkaW5nOiAxcmVtIDEuNXJlbTtcbn1cblxuLmNvbnRlbnQuYWN0aXZlIHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG5cbi5wcmV2aWV3LXRleHQge1xuICBwYWRkaW5nOiAxLjVyZW07XG59XG5cbi5wcmV2aWV3LXRleHQgc3BhbiB7XG4gIG1hcmdpbi10b3A6IDFyZW07XG59XG5cbi5kYXJrLXRoZW1lIHtcbiAgLnBhbmVsIHtcbiAgICBiYWNrZ3JvdW5kOiBjb2xvcnMuJEdyZXk4NTtcbiAgICBjb2xvcjogY29sb3JzLiREYXJrQXBwbGljYXRpb25QcmltYXJ5VGV4dDtcblxuICAgIC5wYW5lbC1oZWFkZXIge1xuICAgICAgYmFja2dyb3VuZDogY29sb3JzLiRHcmV5ODU7XG4gICAgICBjb2xvcjogY29sb3JzLiREYXJrQXBwbGljYXRpb25QcmltYXJ5VGV4dDtcbiAgICB9XG5cbiAgICAuc2lkZWJhciB7XG4gICAgICBiYWNrZ3JvdW5kOiBjb2xvcnMuJEdyZXk4NTtcbiAgICAgIGNvbG9yOiBjb2xvcnMuJERhcmtBcHBsaWNhdGlvblByaW1hcnlUZXh0O1xuXG4gICAgICAuc2l0ZS1saXN0IHtcbiAgICAgICAgLnNpdGUge1xuICAgICAgICAgIGNvbG9yOiBjb2xvcnMuJERhcmtBcHBsaWNhdGlvblRlcnRpYXJ5VGV4dDtcbiAgICAgICAgICBib3JkZXItY29sb3I6IGNvbG9ycy4kRGFya0FwcGxpY2F0aW9uQm9yZGVyO1xuXG4gICAgICAgICAgLnRodW1ibmFpbCB7XG4gICAgICAgICAgICBib3JkZXItY29sb3I6IGNvbG9ycy4kRGFya0FwcGxpY2F0aW9uQm9yZGVyO1xuICAgICAgICAgIH1cblxuICAgICAgICAgIC5uYW1lIHtcbiAgICAgICAgICAgIGNvbG9yOiBjb2xvcnMuJERhcmtBcHBsaWNhdGlvblByaW1hcnlUZXh0O1xuICAgICAgICAgIH1cblxuICAgICAgICAgIHNwYW4ge1xuICAgICAgICAgICAgY29sb3I6IGNvbG9ycy4kRGFya0FwcGxpY2F0aW9uUHJpbWFyeVRleHQ7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iLCJAdXNlICdzYXNzOmNvbG9yJztcblxuJEFCQlJlZDogI2ZmMDAwZjtcblxuLy8gVUkgQmx1ZVxuXG4kVUlCbHVlMTA6ICNlMGYwZmY7XG4kVUlCbHVlMjA6ICNjNWUwZmE7XG4kVUlCbHVlMzA6ICM5ZWJmZjc7XG4kVUlCbHVlNDA6ICM3N2EzZmM7XG4kVUlCbHVlNTA6ICM0Yzg1ZmY7XG4kVUlCbHVlNjA6ICMzMzY2ZmY7IC8vIFByaW1hcnkgaGlnaGxpZ2h0IGNvbG9yXG4kVUlCbHVlNzA6ICMyYTM1ZmY7XG4kVUlCbHVlODA6ICMyYzIwZDQ7XG4kVUlCbHVlOTA6ICMxNjBjOWM7XG4kVUlCbHVlMTAwOiAjMDgwMjYxO1xuJFVJQmx1ZTogJFVJQmx1ZTYwO1xuXG4vLyBDb2xvcnNcbi8vXG4vLyAoMCAtIDUwIGFyZSBhY2Nlc3NpYmxlIG9uIGRhcmsgYmFja2dyb3VuZCBhbmQgNjAgLSAxMTAgb24gbGlnaHQpXG5cbi8vIEdyYXlzXG5cbiRHcmV5MDogI2ZmZmZmZjsgLy8gQ29udGVudCBhcmVhXG4kR3JleTU6IGNvbG9yLmFkanVzdCgkR3JleTAsICRsaWdodG5lc3M6IC01JSk7XG4kR3JleTEwOiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtMTAlKTsgLy8gQXBwbGljYXRpb24gYmFja2dyb3VuZFxuJEdyZXkxNTogY29sb3IuYWRqdXN0KCRHcmV5MCwgJGxpZ2h0bmVzczogLTE1JSk7XG4kR3JleTIwOiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtMjAlKTsgLy8gQmFja2dyb3VuZCBvZiBub3JtYWwgYnV0dG9uXG4kR3JleTI1OiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtMjUlKTtcbiRHcmV5MzA6IGNvbG9yLmFkanVzdCgkR3JleTAsICRsaWdodG5lc3M6IC0zMCUpOyAvLyBJbnB1dCBmaWVsZCBib3JkZXJcbiRHcmV5MzU6IGNvbG9yLmFkanVzdCgkR3JleTAsICRsaWdodG5lc3M6IC0zNSUpO1xuJEdyZXk0MDogY29sb3IuYWRqdXN0KCRHcmV5MCwgJGxpZ2h0bmVzczogLTQwJSk7XG4kR3JleTQ1OiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtNDUlKTtcbiRHcmV5NTA6IGNvbG9yLmFkanVzdCgkR3JleTAsICRsaWdodG5lc3M6IC01MCUpO1xuJEdyZXk1NTogY29sb3IuYWRqdXN0KCRHcmV5MCwgJGxpZ2h0bmVzczogLTU1JSk7XG4kR3JleTYwOiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtNjAlKTsgLy8gU2Vjb25kYXJ5IHRleHRcbiRHcmV5NjU6IGNvbG9yLmFkanVzdCgkR3JleTAsICRsaWdodG5lc3M6IC02NSUpO1xuJEdyZXk3MDogY29sb3IuYWRqdXN0KCRHcmV5MCwgJGxpZ2h0bmVzczogLTcwJSk7XG4kR3JleTc1OiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtNzUlKTtcbiRHcmV5ODA6IGNvbG9yLmFkanVzdCgkR3JleTAsICRsaWdodG5lc3M6IC04MCUpO1xuJEdyZXk4NTogY29sb3IuYWRqdXN0KCRHcmV5MCwgJGxpZ2h0bmVzczogLTg1JSk7XG4kR3JleTkwOiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtOTAlKTsgLy8gUHJpbWFyeSB0ZXh0XG4kR3JleTk1OiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtOTUlKTtcbiRHcmV5MTAwOiBjb2xvci5hZGp1c3QoJEdyZXkwLCAkbGlnaHRuZXNzOiAtMTAwJSk7XG4kR3JleTExMDogIzAwMDAwMDtcblxuLy8gVE9ETzogUmVtb3ZlIG9yaWdpbmFsIGNvbG9yc1xuLy8gJEdyZXkwOiAjZmZmZmZmOyAvLyBDb250ZW50IGFyZWFcbi8vICRHcmV5NTogI2YyZjJmMjtcbi8vICRHcmV5MTA6ICNlNmU2ZTY7IC8vIEFwcGxpY2F0aW9uIGJhY2tncm91bmRcbi8vICRHcmV5MTU6ICNkOWQ5ZDk7IC8vIEFwcGxpY2F0aW9uIGJhY2tncm91bmRcbi8vICRHcmV5MjA6ICNjY2NjY2M7IC8vIEJhY2tncm91bmQgb2Ygbm9ybWFsIGJ1dHRvblxuLy8gJEdyZXkyNTogI2JmYmZiZjtcbi8vICRHcmV5MzA6ICNiM2IzYjM7IC8vIElucHV0IGZpZWxkIGJvcmRlclxuLy8gJEdyZXkzNTogI2E2YTZhNjtcbi8vICRHcmV5NDA6ICM5OTk5OTk7XG4vLyAkR3JleTQ1OiAjOGM4YzhjO1xuLy8gJEdyZXk1MDogIzgwODA4MDtcbi8vICRHcmV5NTU6ICM3MzczNzM7XG4vLyAkR3JleTYwOiAjNjY2NjY2OyAvLyBTZWNvbmRhcnkgdGV4dFxuLy8gJEdyZXk2NTogIzU5NTk1OTtcbi8vICRHcmV5NzA6ICM0ZDRkNGQ7XG4vLyAkR3JleTc1OiAjNDA0MDQwO1xuLy8gJEdyZXk4MDogIzMzMzMzMztcbi8vICRHcmV5ODU6ICMyNjI2MjY7XG4vLyAkR3JleTkwOiAjMWExYTFhOyAvLyBQcmltYXJ5IHRleHRcbi8vICRHcmV5OTU6ICMwZDBkMGQ7XG4vLyAkR3JleTEwMDogIzAwMDAwMDtcblxuLy8gUHVycGxlXG5cbiRQdXJwbGUxMDogI2ZhZTNmYTtcbiRQdXJwbGUyMDogI2ZhYzVmYTtcbiRQdXJwbGUzMDogI2YyOTFmMjtcbiRQdXJwbGU0MDogI2U2NzBlNjtcbiRQdXJwbGU1MDogI2NjNTBjYztcbiRQdXJwbGU2MDogI2ExM2ZhMTtcbiRQdXJwbGU3MDogIzhmMTg4ZjtcbiRQdXJwbGU4MDogIzdhMDk3YTtcbiRQdXJwbGU5MDogIzRhMDE0YTtcbiRQdXJwbGUxMDA6ICMyNDAwMjQ7XG5cbi8vIE1hZ2VudGFcblxuJE1hZ2VudGExMDogI2ZmZTNmMDtcbiRNYWdlbnRhMjA6ICNmZmM3ZTQ7XG4kTWFnZW50YTMwOiAjZmY5NGM5O1xuJE1hZ2VudGE0MDogI2ZmNmJiNTtcbiRNYWdlbnRhNTA6ICNlNjQ5OTc7XG4kTWFnZW50YTYwOiAjYzIzNDdiO1xuJE1hZ2VudGE3MDogI2E4MTM1ZDtcbiRNYWdlbnRhODA6ICM4MjBkNDg7XG4kTWFnZW50YTkwOiAjNTIwMzJhO1xuJE1hZ2VudGExMDA6ICMyZTAwMTY7XG5cbi8vIEJsdWVcblxuJEJsdWUxMDogI2RlZjRmYTtcbiRCbHVlMjA6ICNiM2U2ZmY7XG4kQmx1ZTMwOiAjNmNkNWZmO1xuJEJsdWU0MDogIzJmYzhmNztcbiRCbHVlNTA6ICMwMGFjZWM7XG4kQmx1ZTYwOiAjMWI3YWMyO1xuJEJsdWU3MDogIzAwNWNhMztcbiRCbHVlODA6ICMwMDQ0ODA7XG4kQmx1ZTkwOiAjMDAyODRhO1xuJEJsdWUxMDA6ICMwMzEzMjQ7XG5cbi8vIFRlYWxcblxuJFRlYWwxMDogI2Q3ZjdmMztcbiRUZWFsMjA6ICNiNWViZTI7XG4kVGVhbDMwOiAjN2VkNmM2O1xuJFRlYWw0MDogIzVhYmZhZTtcbiRUZWFsNTA6ICMzZGExOTA7XG4kVGVhbDYwOiAjM2I3ODZlO1xuJFRlYWw3MDogIzE5NWM1MDtcbiRUZWFsODA6ICMxNjQ1M2Q7XG4kVGVhbDkwOiAjMDkyOTIzO1xuJFRlYWwxMDA6ICMwMDE3MTI7XG5cbi8vIFB1cnBsZVxuXG4kUHVycGxlMTA6ICNmYWUzZmE7XG4kUHVycGxlMjA6ICNmYWM1ZmE7XG4kUHVycGxlMzA6ICNmMjkxZjI7XG4kUHVycGxlNDA6ICNlNjcwZTY7XG4kUHVycGxlNTA6ICNjYzUwY2M7XG4kUHVycGxlNjA6ICNhMTNmYTE7XG4kUHVycGxlNzA6ICM4ZjE4OGY7XG4kUHVycGxlODA6ICM3YTA5N2E7XG4kUHVycGxlOTA6ICM0YTAxNGE7XG4kUHVycGxlMTAwOiAjMjQwMDI0O1xuXG4vLyBNYWdlbnRhXG5cbiRNYWdlbnRhMTA6ICNmZmUzZjA7XG4kTWFnZW50YTIwOiAjZmZjN2U0O1xuJE1hZ2VudGEzMDogI2ZmOTRjOTtcbiRNYWdlbnRhNDA6ICNmZjZiYjU7XG4kTWFnZW50YTUwOiAjZTY0OTk3O1xuJE1hZ2VudGE2MDogI2MyMzQ3YjtcbiRNYWdlbnRhNzA6ICNhODEzNWQ7XG4kTWFnZW50YTgwOiAjODIwZDQ4O1xuJE1hZ2VudGE5MDogIzUyMDMyYTtcbiRNYWdlbnRhMTAwOiAjMmUwMDE2O1xuXG4vLyBCbHVlXG5cbiRCbHVlMTA6ICNkZWY0ZmE7XG4kQmx1ZTIwOiAjYjNlNmZmO1xuJEJsdWUzMDogIzZjZDVmZjtcbiRCbHVlNDA6ICMyZmM4Zjc7XG4kQmx1ZTUwOiAjMDBhY2VjO1xuJEJsdWU2MDogIzFiN2FjMjtcbiRCbHVlNzA6ICMwMDVjYTM7XG4kQmx1ZTgwOiAjMDA0NDgwO1xuJEJsdWU5MDogIzAwMjg0YTtcbiRCbHVlMTAwOiAjMDMxMzI0O1xuXG4vLyBUZWFsXG5cbiRUZWFsMTA6ICNkN2Y3ZjM7XG4kVGVhbDIwOiAjYjVlYmUyO1xuJFRlYWwzMDogIzdlZDZjNjtcbiRUZWFsNDA6ICM1YWJmYWU7XG4kVGVhbDUwOiAjM2RhMTkwO1xuJFRlYWw2MDogIzNiNzg2ZTtcbiRUZWFsNzA6ICMxOTVjNTA7XG4kVGVhbDgwOiAjMTY0NTNkO1xuJFRlYWw5MDogIzA5MjkyMztcbiRUZWFsMTAwOiAjMDAxNzEyO1xuXG4vLyBHcmVlblxuXG4kR3JlZW4xMDogI2UyZjdkZjtcbiRHcmVlbjIwOiAjYmZlZGJiO1xuJEdyZWVuMzA6ICM5OGQ2OTQ7XG4kR3JlZW40MDogIzc1YmE3MDtcbiRHcmVlbjUwOiAjNTFhMzRiO1xuJEdyZWVuNjA6ICM0NzdhNDM7XG4kR3JlZW43MDogIzFlNjExOTtcbiRHcmVlbjgwOiAjMWI0NzE4O1xuJEdyZWVuOTA6ICMxMDI5MGU7XG4kR3JlZW4xMDA6ICMwMTFhMDA7XG5cbi8vIFllbGxvd1xuXG4kWWVsbG93MTA6ICNmYWY1YjY7XG4kWWVsbG93MjA6ICNlZGU1NmY7XG4kWWVsbG93MzA6ICNkNmM5MTg7XG4kWWVsbG93NDA6ICNiNWFhMGQ7XG4kWWVsbG93NTA6ICM5NjhkMGI7XG4kWWVsbG93NjA6ICM3NTZlMDk7XG4kWWVsbG93NzA6ICM1MjRjMDA7XG4kWWVsbG93ODA6ICMzYjM4MTM7XG4kWWVsbG93OTA6ICMyNDIxMDI7XG4kWWVsbG93MTAwOiAjMTIxMTAxO1xuXG4vLyBHb2xkXG5cbiRHb2xkMTA6ICNmZmVkZGI7XG4kR29sZDIwOiAjZmZkM2E4O1xuJEdvbGQzMDogI2YyYWM2NjtcbiRHb2xkNDA6ICNkOThmNDU7XG4kR29sZDUwOiAjYzI3MTIxO1xuJEdvbGQ2MDogI2E2NTUwMztcbiRHb2xkNzA6ICM3NTNiMDA7XG4kR29sZDgwOiAjNTQyYzA0O1xuJEdvbGQ5MDogIzMzMWIwMjtcbiRHb2xkMTAwOiAjMWEwZTAwO1xuXG4vLyBPcmFuZ2VcblxuJE9yYW5nZTEwOiAjZmZlYWU4O1xuJE9yYW5nZTIwOiAjZmZjZWM0O1xuJE9yYW5nZTMwOiAjZmY5ZjhjO1xuJE9yYW5nZTQwOiAjZjU3YzY0O1xuJE9yYW5nZTUwOiAjZWQ1NzM5O1xuJE9yYW5nZTYwOiAjZDkzNjE2O1xuJE9yYW5nZTcwOiAjYTgyMDA1O1xuJE9yYW5nZTgwOiAjNzUxYTA4O1xuJE9yYW5nZTkwOiAjNGQwZDAwO1xuJE9yYW5nZTEwMDogIzI5MDcwMDtcblxuLy8gUmVkXG5cbiRSZWQxMDogI2ZmZThlYTtcbiRSZWQyMDogI2ZmYzljZDtcbiRSZWQzMDogI2ZmOTlhMDtcbiRSZWQ0MDogI2ZmNzU3ZTtcbiRSZWQ1MDogI2ZmNDc1NDtcbiRSZWQ2MDogI2UxMmUyZTtcbiRSZWQ3MDogI2NjMDgxNTtcbiRSZWQ4MDogI2EzMDAwNTtcbiRSZWQ5MDogIzVjMDAwNjtcbiRSZWQxMDA6ICMzZTAwMDA7XG5cbi8vIFN0YXR1cyBjb2xvcnNcblxuJFN0YXR1c1llbGxvdzogI2ZmZDgwMDtcbiRTdGF0dXNPcmFuZ2U6ICNmZjczMDA7XG4kU3RhdHVzUmVkOiAjZjAzMDQwO1xuJFN0YXR1c01hZ2VudGE6ICNjYjJiZDU7XG4kU3RhdHVzR3JlZW46ICMwY2E5MTk7XG4kU3RhdHVzQmx1ZTogIzMzNjZmZjtcblxuLy8gU2V0dXAgV2l6YXJkIHNwZWNpZmljXG5cbiRXaXphcmRZZWxsb3c6ICNkY2E5MDA7XG5cbi8vIFRoZW1lIC0gZGFya1xuXG4kRGFya0FwcGxpY2F0aW9uQmFja2dyb3VuZDogJEdyZXkxMDA7XG4kRGFya0FwcGxpY2F0aW9uUGFuZWxCYWNrZ3JvdW5kOiAkR3JleTkwO1xuXG4kRGFya0FwcGxpY2F0aW9uUHJpbWFyeVRleHQ6ICRHcmV5MTA7XG4kRGFya0FwcGxpY2F0aW9uU2Vjb25kYXJ5VGV4dDogJEdyZXk1MDtcbiREYXJrQXBwbGljYXRpb25UZXJ0aWFyeVRleHQ6ICRHcmV5NTA7XG5cbiREYXJrQXBwbGljYXRpb25JbnB1dEJvcmRlcjogJEdyZXk3NTtcbiREYXJrQXBwbGljYXRpb25Cb3JkZXI6ICRHcmV5ODA7XG5cbiREYXJrQXBwbGljYXRpb25SZWd1bGFyQnV0dG9uOiAkR3JleTIwO1xuXG4vLyBUaGVtZSAtIGxpZ2h0XG5cbiRMaWdodEFwcGxpY2F0aW9uQmFja2dyb3VuZDogJEdyZXk1O1xuJExpZ2h0QXBwbGljYXRpb25QYW5lbEJhY2tncm91bmQ6ICRHcmV5MDtcblxuJExpZ2h0QXBwbGljYXRpb25QcmltYXJ5VGV4dDogJEdyZXk5MDtcbiRMaWdodEFwcGxpY2F0aW9uU2Vjb25kYXJ5VGV4dDogJEdyZXk2MDtcbiRMaWdodEFwcGxpY2F0aW9uVGVydGlhcnlUZXh0OiAkR3JleTUwO1xuXG4kTGlnaHRBcHBsaWNhdGlvbklucHV0Qm9yZGVyOiAkR3JleTIwO1xuJExpZ2h0QXBwbGljYXRpb25Cb3JkZXI6ICRHcmV5MTA7XG5cbiRMaWdodEFwcGxpY2F0aW9uUmVndWxhckJ1dHRvbjogJEdyZXk3MDsiXX0= */